import Vue from 'vue';
import Vuetify from 'vuetify';
import router from './router';
import { store } from './store';
import 'vuetify/dist/vuetify.css';
import VueCordova from 'vue-cordova';
import VueResource from 'vue-resource';
import VueHead from 'vue-head';
import axios from "axios";

import App from './App';
import Vueditor from 'vueditor';
import './components/shared/assets/css/shared.css';
import 'vueditor/dist/style/vueditor.min.css';
import '@mdi/font/css/materialdesignicons.css'

import barCode from './components/shared/assets/js/JsBarcode.all.min.js';

Vue.prototype.$axios = axios;

Vue.use(Vuetify);
Vue.config.productionTip = false;
Vue.use(VueCordova);
Vue.use(VueResource);

import { getToken } from './auth';

let config = {
  toolbar: [
    'bold', 'italic', 'foreColor'
  ]
};

Vue.use(Vueditor, config);

Vue.use(VueHead);

if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script');
  cordovaScript.setAttribute('type', 'text/javascript');
  cordovaScript.setAttribute('src', 'cordova.js');
  document.body.appendChild(cordovaScript);
}

import Header from './components/shared/Header.vue';
import Sidebar from './components/shared/Sidebar.vue';

Vue.component('mo-header', Header);
Vue.component('mo-sidebar', Sidebar);

function fncGetObjAuthorize() {
  if( store.state.objAuthorize != undefined && store.state.objAuthorize != '' && store.state.objAuthorize.length > 0 ) {
    try {
      return JSON.parse(store.state.objAuthorize);
    } catch(e) {
      return false;
    }
  }

  return false;
}

function fncNeedsCustomerSetup(objAuth) {
  return objAuth != false && (String(objAuth.type) == '2' || String(objAuth.type) == '4');
}

router.beforeEach((to, from, next) => {
  if( fncNeedsCustomerSetup(fncGetObjAuthorize()) && to.path != '/customer-setup' ) {
    next('/customer-setup');
  } else {
    next();
  }
});

var objAuth = fncGetObjAuthorize();
var shouldShowCustomerSetup = fncNeedsCustomerSetup(objAuth);

if( shouldShowCustomerSetup && router.currentRoute.path != '/customer-setup' ) {
  router.replace('/customer-setup');
}

if( objAuth != false ) {
  var manu = String(objAuth.manufacturer);
} else {
  var manu = store.state.setManufacturer;
}

var newManu = '';

if( window.location.href.includes('#/survey') && window.location.href.includes('manufacturer') && window.location.href.includes('auth') ) {

  var params = new URLSearchParams(window.location.hash);
      newManu = params.get('manufacturer');

}

if( newManu != '' && newManu != undefined && newManu != null ) {
  manu = newManu;
}

var tokenPromise = getToken( manu, shouldShowCustomerSetup );

tokenPromise.then(token => {

    if( window.location.href.includes('#/survey') && newManu != '' && newManu != undefined && newManu != null ) {

      Vue.http.interceptors.push((request, next) => {

        request.headers.set('X-Manufacturer', String(manu));
        request.headers.set('X-Token', token);
        next();

      });


    } else if( store.state.objAuthorize != [] && store.state.objAuthorize.length > 0 ) {
      Vue.http.interceptors.push((request, next) => {

        if ( !request.url.includes('api/v1/line_items') && !request.url.includes('api/v1/lock_pricelist') && !request.url.includes('api/v1/clone_pricelist') && !request.url.includes('api/v1/pricelist_items') && !request.url.includes('api/v1/pricelists') && !request.url.includes('api/v1/articles') && !request.url.includes('ranges') && !request.url.includes('middleware') && !request.url.includes('process')) {

          const fragment = window.location.hash; // "#/survey?agentEmail=...&manufacturer=385889803"
          const queryString = fragment.split('?')[1]; // Get the part after '?'
          const params = new URLSearchParams(queryString);
          const manufacturer = params.get('manufacturer');

          if( manufacturer != undefined && manufacturer != null && manufacturer != '' ) {
            request.headers.set('X-Manufacturer-Logged', String(manufacturer))//request.headers.set('X-Manufacturer-Logged', String(setManu));
            request.headers.set('X-Token', token);

          } else {
            request.headers.set('X-Manufacturer-Logged', String(objAuth.manufacturer))//request.headers.set('X-Manufacturer-Logged', String(setManu));

            if( token != 'true' && typeof token != 'boolean' ) {
              request.headers.set('X-Token', token);
            }

            //
          }
        }

        next();

      });

    } else if( newManu != '' && newManu != undefined && newManu != null ) {

      Vue.http.interceptors.push((request, next) => {

        request.headers.set('X-Manufacturer', String(manu));

        if( token != 'true' && typeof token != 'boolean' ) {
        request.headers.set('X-Token', token);
        }
        next();

      });

    }

    new Vue({
      el: '#app',
      router,
      store,
      template: '<App/>',
      components: { App },
      head: {
        meta: [{
          name: 'viewport',
          content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
        }]
      },
      beforeCreate() {
        var appOnline = navigator.onLine;
        if( appOnline !== true ) {
          router.replace('/network');
        } else if( fncNeedsCustomerSetup(fncGetObjAuthorize()) && router.currentRoute.path != '/customer-setup' ) {
          router.replace('/customer-setup');
        } else if (store.getters.jwtAuth === '' || store.getters.jwtAuth === undefined) {
          if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/survey' && router.currentRoute.path !== '/customer-setup') {
            router.replace('/login');
          }
        } else if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/survey') {
          if (store.getters.jwtAuth === '') {
            router.replace('/login');
          }
        } /*else if (router.currentRoute.path === '/login' && ( store.getters.jwtAuth !== '' || store.getters.jwtAuth !== undefined ) ) {
			router.replace('/');
		}*/
      }
    })



});
